import React, { Component, Fragment } from 'react';
import SearchModalCUPSTable from './SearchModalCUPSTable';
import SearchModalCUPSTableActions from './SearchModalCUPSTableActions';
import Modal from '@material-ui/core/Modal';
import { Col, Row, Button } from 'reactstrap';
import TextField from '@material-ui/core/TextField';

class SearchModalCUPS extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cupsData: [],
            loading: false,
            filterText: null
        };
    }

    componentDidMount = () => {

    }

    searchDataCUPS = async () => {
        this.setState({ loading: true });
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'cups/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({ filtro: this.state.filterText })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Error consultando los CUPS");
            }
        }).then((cupsData) => {
            if(cupsData.existe == true)
            {
                this.setState({ cupsData: cupsData.contenido, loading: false }, () => {
                    console.log("cupsData: ", this.state.cupsData);
                });
            }
            else
            {
                this.setState({ cupsData: [], loading: false }, () => {
                });
            }
        }).catch(err => {
            console.log(err);
            this.setState({ loading: false });
        });
    }

    render() {
        return (<Fragment>
            <Modal
                open={this.props.openModalCUPS}
                onClose={() => {
                    this.props.closeModalCUPS();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex"  style={{ width: '90%', height: '75%', margin: 10, overflowY: "auto" }}>
                    <div>
                        <h5 className="bold-text">Procedimiento</h5>
                    </div>

                    <label>
                        Escriba el Código CUPS o su Nombre y presione Enter o haz Click en el Boton buscar
                    </label>
                    <br /><br />

                    <div>
                        <Row>
                            <Col md={10}>
                                <TextField
                                    required
                                    className="medical-material-form__field"
                                    style={{ width: '100%' }}
                                    id="cie10-filter"
                                    label="Código CUPS o Nombre"
                                    type="text"
                                    value={this.state.filterText}
                                    onChange={(e) => {
                                        this.setState({ filterText: e.target.value });
                                    }}
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            this.searchDataCUPS();
                                        }
                                    }}
                                />
                            </Col>
                            <Col md={2}>
                                <Button
                                    className="btn btn-sm"
                                    color="primary"
                                    onClick={() => {
                                        this.searchDataCUPS();
                                    }}
                                    style={{ margin: 10 }}
                                >
                                    Buscar
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        {!this.state.loading ?
                            <SearchModalCUPSTable
                                title=""
                                reactTableData={this.state.cupsData}
                                config={{
                                    withPagination: true,
                                    withSearchEngine: false,
                                    isSortable: false,
                                    watchCustomMenu: false
                                }}
                                ReactTableActions={SearchModalCUPSTableActions}
                                Callback={(procedure) => {
                                    this.props.Callback(procedure);
                                }}
                            /> : <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                <div class="load__icon-wrap">
                                    <svg class="load__icon">
                                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                    </svg>
                                </div>
                            </div>}
                        {!this.state.loading && this.state.cupsData.length == 0 ?
                            <div style={{ margin: 'auto', width: 270, height: 420 }}>
                                No hay elementos que mostrar
                            </div>
                            : null}
                    </div>
                </div>
            </Modal>

        </Fragment>);
    }
}

export default SearchModalCUPS;
